// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ImageNumber-container-5qvAL{background-color:hsla(0,0%,100%,.6);border-radius:2px;padding:.25rem;position:absolute;right:10px;top:10px}", ""]);
// Exports
exports.locals = {
	"container": "ImageNumber-container-5qvAL"
};
module.exports = exports;
